export const SCENE_SIZE = 10000; //  一万米
